import { TabsProps } from 'antd';
import { DataSheetActionKind } from 'components/layouts/components/data-sheet/hooks/data-sheet-manage';
import { useDataSheetWrapper } from 'components/layouts/components/data-sheet/wrapper';
import { DataSheetSiderTabs } from 'components/tabs/data-sheet-sider-tabs';
import { useIsXXlScreen } from 'hooks/use-breakpoint';
import { TabTables } from './tab-tables';
import { useEffect } from 'react';
import { ConnectionRejectTableSection } from './connection-reject-table';

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'Nodes',
  },
  {
    key: '2',
    label: 'Connections',
  },
  {
    key: '3',
    label: 'Tables',
  },
];

export const LeftSection = () => {
  const { dispatch } = useDataSheetWrapper();

  const isXXL = useIsXXlScreen();
  const onChange = (activeKey: string) => {
    switch (activeKey) {
      case '3':
        dispatch({ type: DataSheetActionKind.TABLES_SELECTED, payload: {} });
        break;
      case '2':
        dispatch({ type: DataSheetActionKind.CONNECTIONS_SELECTED, payload: {} });
        break;
      default:
        dispatch({ type: DataSheetActionKind.ALL_TYPE_SELECTED, payload: {} });
    }
  };

  useEffect(() => {
    if (dispatch) {
      dispatch({ type: DataSheetActionKind.ALL_TYPE_SELECTED, payload: {} });
    }
  }, [dispatch]);

  return (
    <DataSheetSiderTabs
      tabBarGutter={isXXL ? 50 : 30}
      destroyInactiveTabPane
      defaultActiveKey="1"
      items={items.map((item) => ({
        ...item,
        children:
          item.key === '1' ? (
            <>
              <TabTables isCheckable noColors hideConnection />
            </>
          ) : item.key === '2' ? (
            <>
              <ConnectionRejectTableSection />
            </>
          ) : (
            <>
              <TabTables />
            </>
          ),
      }))}
      onChange={onChange}
    />
  );
};
